// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
//import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

//import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

//import './icons' // icon
//import './errorLog'// error log
import './assets/icon/iconfont.css'
import './permission' // permission control
import * as filters from './filters' // global filters
import './styles/index.scss'

Vue.use(Element, {
  size: 'medium', // set element-ui default size
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js